// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"c093e496","253":"77ad9307","341":"d04918e4","438":"a3d103c0","706":"67ccbc12","726":"99953625"}[chunkId] + ".chunk.js";
};